module.exports = __webpack_public_path__ + "static/red2-57bdc075be49e407022a645a3ec5de8a.png";